import { HttpResponse } from 'app/types-shared';
import { UiDefinition } from 'app/infrastructure/ui/types-uidefinition';
import { RemoteData } from 'app/infrastructure/remote-data';
import { endpoints } from './endpoints';

export const api = {

  uiDefinition: async (caseTypeId: number, caseContextId?: number, eTag?: string): Promise<HttpResponse<UiDefinition>> => {

    const remoteData = new RemoteData(endpoints.ui).resource<HttpResponse<UiDefinition>>()
      .withId(caseTypeId);

    if (caseContextId) {
      remoteData.filter({ caseContextId });
    }

    if (eTag) {
      remoteData.withIfNoneMatch(eTag);
    }

    return await remoteData.response();
  }
};
